import React, { useCallback } from "react";
import { connect } from "react-redux";
import { Table } from "antd";
import { bindActionCreators } from "redux";
import { Creators as ReportActions } from "store/report/report-duck";
import { IMovementItems } from "store/report/report-model";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

interface IPropsScreenReportGrid {
  movementItems?: Array<IMovementItems>;
  movementTotalItems?: number;
  itemsByPage?: number;
  pageIndex?: number;
  columnsTable: any;
  isLoadingMovementsRegisters: boolean;
}
interface IDispatchProps {
  reportMovementsFetchRegisterAsync: (...args) => void;
  reportMovementChangeFieldValue: (...args) => void;
}

export type IProps = IPropsScreenReportGrid & IDispatchProps;

const MovementsReportGrid = ({
  movementItems,
  movementTotalItems,
  pageIndex,
  columnsTable,
  isLoadingMovementsRegisters,
  reportMovementsFetchRegisterAsync,
  reportMovementChangeFieldValue,
}: IProps) => {
  const fetchMovements = useCallback(() => reportMovementsFetchRegisterAsync(), [reportMovementsFetchRegisterAsync]);

  const handleTableChange = (pagination) => {
    reportMovementChangeFieldValue("itemsByPage", pagination.pageSize);
    reportMovementChangeFieldValue("pageIndex", pagination.current);
    fetchMovements();
  };

  const TITLEPAGINATION = [useTranslation({ id: "showing" }), useTranslation({ id: "of" }), useTranslation({ id: "registers" })];
  return (
    <S.MovementsTableContainer>
      <Table
        rowKey="id"
        columns={[...columnsTable]}
        style={{ whiteSpace: "pre-wrap" }}
        dataSource={movementItems}
        pagination={{
          current: pageIndex,
          defaultCurrent: pageIndex,
          pageSizeOptions: ["10", "20", "50"],
          total: movementTotalItems,
          showSizeChanger: true,
          defaultPageSize: 10,
          showTotal: (total, range) => `${TITLEPAGINATION[0]} ${range[0]}-${range[1]} ${TITLEPAGINATION[1]} ${total} ${TITLEPAGINATION[2]}`,
        }}
        onChange={handleTableChange}
        loading={isLoadingMovementsRegisters}
        sticky
        scroll={{ x: 1500 }}
      />
    </S.MovementsTableContainer>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...ReportActions }, dispatch);

const mapStateToProps = (state) => ({
  movementItems: state.Report.movementItems,
  movementTotalItems: state.Report.movementTotalItems,
  itemsByPage: state.Report.movementFilter.itemsByPage,
  pageIndex: state.Report.movementFilter.pageIndex,
  isLoadingMovementsRegisters: state.Report.isLoadingMovementsRegisters,
});

export default connect(mapStateToProps, mapDispatchToActions)(MovementsReportGrid);
